$(document).ready(function(){
    $('.image_text_main_carousel').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/2681/2616/files/Component_36.png?v=1708947104'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/2681/2616/files/Component_36.png?v=1708947104'/></button>",
      });
      

    
});